import useRoomTypeContext from "@Pages/PropertyPage/components/RoomTypeSection/context/useRoomTypeContext";
import styles from "./footer.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import {
  filterAvailableRooms,
  getPricingPriceFormatted,
  getRoomTypeTabData,
} from "@Pages/PropertyPage/components/RoomTypeSection/utils";
import Button from "@Components/Button";
import Image from "@Components/Image";
import getImagePath from "@Utils/getImagePath";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import { PAGE } from "constants/configConstants";
import getFeaturedImage from "@Utils/getFeaturedImage";
import useTranslationHook from "hooks/useTranslationHook";
//

const Footer = ({ type, id, onClose }: { type: string; id: number; onClose: any }) => {
  const {
    roomTypes: { data = [] },
  } = useRoomTypeContext();
  const { propertyData } = useRoomTypeContext();
  const { t } = useTranslationHook();

  const tabdata = getRoomTypeTabData(data);
  const filteredRooms = filterAvailableRooms(tabdata[type], id);

  const onButtonClick = (selectedId = null) => {
    onClose();
    if (selectedId) {
      document
        .getElementById(`room-${selectedId}`)
        ?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });

      gtagEventEmitter({
        action: "room_clicked",
        category: PAGE.INVENTORY,
        label: "view_more_details",
      });
    } else {
      document
        .getElementById(`room-${filteredRooms[0].id}`)
        ?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });

      gtagEventEmitter({
        action: "see_other_rooms_clicked",
        category: PAGE.INVENTORY,
        label: "view_more_details",
      });
    }
  };

  return (
    <>
      {filteredRooms.length > 0 && (
        <div className={styles.container}>
          <div className={styles.divider} />
          <div className={styles.title}>
            {t("propertypage.roomtypesectiondynamic.roomtypecard.checkoutotherrooms")}
          </div>
          <div className={styles.subContainer}>
            {filteredRooms?.map((room: any) => (
              <div
                className={styles.card}
                onClick={() => onButtonClick(room?.id)}
                tabIndex={0}
                onKeyDown={() => onButtonClick(room?.id)}
                role="button"
              >
                <Image
                  src={getImagePath(
                    room?.images[0]?.base_path || getFeaturedImage(propertyData?.images)?.base_path,
                    "small",
                  )}
                  height={100}
                  width="100%"
                />
                <h6 className={styles.cardTitle}>{room?.name}</h6>
                <div className={styles.cardSubTitle}>
                  {t("propertypage.roomtypesectiondynamic.roomtypecard.startsfrom")}&nbsp;
                  <span>{getPricingPriceFormatted(room.pricing, { price_per_person: false })}</span>
                </div>
              </div>
            ))}
          </div>
          <Button variant="outline" className={styles.btn} onClick={() => onButtonClick()}>
            {t("propertypage.roomtypesectiondynamic.roomtypecard.seeotherrooms")}
          </Button>
        </div>
      )}
    </>
  );
};

export default wrapperHOC(Footer, {
  componentName: "Footer-ViewMoreDetailsModal-RoomTypeCard-PropertyPage",
  showForChina: true,
});
